document.addEventListener('DOMContentLoaded', function() {
	replaceTextInPage = (oldText, newText) => {
		replaceTextInNode = (node) => {
			if(node.nodeType === 3) // Text node
			{
				node.nodeValue = node.nodeValue.replace(new RegExp(oldText, 'g'), newText);
			}
			else if(node.nodeType === 1) { // Element node
				// Avoid certain tags where changing inner text might be problematic or unintended
				if(!/^(script|style|textarea|input|select)$/i.test(node.tagName)) {
					for (var i = 0; i < node.childNodes.length; i++) {
						replaceTextInNode(node.childNodes[i]);
					}
				}
			}
		}

		replaceTextInNode(document.body);
	}

	// Call the function to acheive our requirement...
	
	replaceTextInPage('multibiotics', 'Multi-Biotics');
	replaceTextInPage('Multibiotics', 'Multi-Biotics');
	replaceTextInPage('Multibiotic', 'Multi-Biotic');
	
	replaceTextInPage('multibiotic', 'Multi-Biotic');
	replaceTextInPage('LoveBug Multi-biotics', 'Lovebug');
	replaceTextInPage('LoveBug Multi-biotic', 'Lovebug');
	replaceTextInPage('LoveBug', 'Lovebug');
	replaceTextInPage('probiotics', 'multi-biotics');
	replaceTextInPage('Probiotics', 'Multi-Biotics');
	replaceTextInPage('Probiotic', 'Multi-Biotic');
	replaceTextInPage('probiotic', 'multi-biotic');
replaceTextInPage('hello@lovebugmulti-biotics.com', 'hello@lovebugprobiotics.com');

	$(".pagination-btn").on("click", function(){
		replaceTextInPage('multibiotics', 'Multi-Biotics');
		replaceTextInPage('Multibiotics', 'Multi-Biotics');
		replaceTextInPage('Multibiotic', 'Multi-Biotic');
		
		replaceTextInPage('multibiotic', 'Multi-Biotic');
		replaceTextInPage('LoveBug Multi-biotics', 'Lovebug');
		replaceTextInPage('LoveBug Multi-biotic', 'Lovebug');
		replaceTextInPage('LoveBug', 'Lovebug');
		replaceTextInPage('probiotics', 'multi-biotics');
		replaceTextInPage('Probiotics', 'Multi-Biotics');
		replaceTextInPage('Probiotic', 'Multi-Biotic');
		replaceTextInPage('probiotic', 'multi-biotic');
		replaceTextInPage('hello@lovebugmulti-biotics.com', 'hello@lovebugprobiotics.com');
	});
});

